import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';


const holiDaySMS = lazy(() => import('../../container/holiday-sms'));

const HoliDaySMS = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/holiDaySMS`} component={holiDaySMS}/>
        </Switch>
    );
};

export default HoliDaySMS;
